export const e2eUser = {
  id: '00000000-0000-0000-0000-000000000001',
  roles: [
    'TERMINALS',
    'PARCEL_SHOPS',
    'REPRINT_LABELS',
    'CCC_RETURN_HUBS',
    'LABEL_REQUESTS',
    'SERVICEPOINT_VENDORS',
    'CCC',
    'REPORTS',
    'ORGANISATIONS',
    'ADMIN_USERS',
    'USERS',
    'EMAIL_STATUS',
    'MARKETING',
  ],
}
